var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSmsMessenger = function SvgSmsMessenger(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 32,
    viewBox: "0 0 18 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.286 2.667c0-1.472-1.17-2.667-2.612-2.667h-13.061c-1.442 0-2.612 1.195-2.612 2.667v26.667c0 1.472 1.17 2.667 2.612 2.667h13.061c1.442 0 2.612-1.195 2.612-2.667v-26.667zM7.184 2.667h3.918c0.361 0 0.653 0.299 0.653 0.667s-0.293 0.667-0.653 0.667h-3.918c-0.361 0-0.653-0.299-0.653-0.667s0.293-0.667 0.653-0.667zM9.143 29.333c-0.722 0-1.306-0.597-1.306-1.333s0.584-1.333 1.306-1.333c0.721 0 1.305 0.597 1.305 1.333s-0.584 1.333-1.305 1.333zM15.673 25.333h-13.061v-18.699h13.061v18.699z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsMessenger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sms-messenger.6853693f.svg";
export { ForwardRef as ReactComponent };